/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Marker } from './Marker';
import { LineStyle, MarkerShapes } from '#utils/UNSAFE_visTypes/common';
import { Line } from './Line';
import { ColorProps } from '#utils/UNSAFE_interpolations/colors';
import { styles } from './themes/SvgShapesStyles.css';
import { classNames } from '#utils/UNSAFE_classNames';
import { Property } from 'csstype';

type SymbolProps = {
  markerShape: MarkerShapes | 'none';
  lineStyle?: LineStyle | 'none';
  lineWidth?: number;
  lineColor?: ColorProps['color'];
  borderColor?: Property.BorderColor;
  markerColor?: ColorProps['color'];
  setAspectRatioNone?: boolean;
  setAbsolutePos?: boolean;
  lineLength?: number;
  outerBorderColor?: Property.BorderColor;
  tx?: number;
  ty?: number;
  markerScale?: number;
};

const MARKER_SHAPE_RATIO = 0.6;
const MAX_SCALE = 1;
export const SvgSymbol = ({
  markerShape,
  lineStyle = 'none',
  lineLength,
  lineWidth,
  lineColor,
  borderColor,
  markerColor,
  setAspectRatioNone,
  setAbsolutePos = false,
  outerBorderColor,
  markerScale,
  tx = 50,
  ty = 50
}: SymbolProps) => {
  const scale = markerScale ?? (lineStyle != 'none' ? MARKER_SHAPE_RATIO : MAX_SCALE);
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      class={classNames([styles.svgSymbolBase, setAbsolutePos ? styles.svgAbsolutePos : ''])}
      preserveAspectRatio={setAspectRatioNone ? 'none' : undefined}>
      {lineStyle != 'none' && (
        <Line
          lineStyle={lineStyle}
          lineWidth={lineWidth}
          color={lineColor}
          lineLength={lineLength}
        />
      )}

      {markerShape != 'none' && (
        <Marker
          type={markerShape}
          scale={scale}
          height={100}
          width={100}
          tx={tx}
          ty={ty}
          preserveRectAspectRatio={!setAspectRatioNone}
          fill={markerColor}
          stroke={borderColor}
          outerStroke={outerBorderColor}
          outerStrokeWidth={4.5} // TODO: create variables for this
          innerStrokeWidth={1.5}
        />
      )}
    </svg>
  );
};
